import { GALLERY_IMAGES, IMAGE_MODAL_DETAILS } from '../actions';


export const galleryImages = (state = {}, action) => {
  switch (action.type) {
    case GALLERY_IMAGES:
      return action.payload;
    default:
      return state;
  }
};

export const imageDetails = (state = {}, action) => {
  switch (action.type) {
    case IMAGE_MODAL_DETAILS:
      return action.payload;
    default:
      return state;
  }
};
